<template>
  <v-img src="/media/img/stop1.png" class="rounded-xl">
    <payment-user-info
      :item="item"
      :settings="settings"
      color="grey lighten-3"
      text-color="grey--text text--darken-1"
    ></payment-user-info>

    <v-row no-gutters justify="center" align="center" class="stop-info-text">
      <div class="poppins-bold white--text">
        <p class="text-center" :style="{ 'font-size': stopFontSize }">
          {{ $t("stop") }}
        </p>
        <p class="text-center">
          {{ translate(item.user.message.lastStatusMessage) }}
        </p>
      </div>
    </v-row>
  </v-img>
</template>

<script>
import PaymentUserInfo from "@/components/canteen/cards/components/PaymentUserInfo.vue";
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
    },
  },
  components: {
    PaymentUserInfo,
  },
  computed: {
    stopFontSize() {
      if (this.device?.isMobile) return "36px";
      if (this.device?.isTablet) return "48px";
      return "72px";
    },
  },
};
</script>

<style scoped>
.stop-info-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 22px;
  padding-top: 120px;
}
</style>
